"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.problemDetails = exports.paginationQuery = exports.idempotencyKey = exports.currencyCode = exports.accountCode = exports.uuid = exports.isoDate = exports.moneyString = void 0;
const zod_1 = require("zod");
/** مبلغ مالى كنص عشرى — لا يُنقل المال أبدًا كـ number فى الـ API. */
exports.moneyString = zod_1.z
    .string()
    .regex(/^-?\d{1,16}(\.\d{1,4})?$/, 'amount must be a decimal string with up to 4 decimals');
exports.isoDate = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
exports.uuid = zod_1.z.string().uuid();
exports.accountCode = zod_1.z.string().min(1).max(32);
exports.currencyCode = zod_1.z.string().length(3).toUpperCase();
/** مفتاح منع التكرار — يُرسل فى ترويسة Idempotency-Key لكل عملية مالية. */
exports.idempotencyKey = zod_1.z.string().min(8).max(128);
exports.paginationQuery = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(50),
});
/**
 * شكل الخطأ الموحَّد (RFC 9457) — يُرسله فلتر واحد لكل المسارات، فالعميل
 * يقرأ الخطأ بفرع واحد لا بفرع لكل مصدر.
 */
exports.problemDetails = zod_1.z.object({
    type: zod_1.z.string(),
    title: zod_1.z.string(),
    status: zod_1.z.number().int(),
    detail: zod_1.z.string().optional(),
    /** المسار الذى رُفض — للتشخيص لا للبرمجة عليه. */
    instance: zod_1.z.string().optional(),
    /** نفس المعرّف المُردّ فى ترويسة `x-request-id` والمكتوب فى سجل التدقيق. */
    requestId: zod_1.z.string().optional(),
    /** مشاكل تفصيلية: من محرك الترحيل بأكوادها، أو من تحقق العقد بمساراتها. */
    issues: zod_1.z
        .array(zod_1.z.object({
        code: zod_1.z.string(),
        message: zod_1.z.string(),
        lineIndex: zod_1.z.number().int().optional(),
        accountCode: zod_1.z.string().optional(),
        path: zod_1.z.string().optional(),
    }))
        .optional(),
});
//# sourceMappingURL=common.js.map